import LzYSystem from '@lz-modules/built-in/System';
import ConfigurationsComponent from './ConfigurationsScreen';
import lzGUsers from './Users/config';

const SystemModule = new LzYSystem({

    configsPage: <ConfigurationsComponent />,
    noMedia: true,
    noRoles: true,
    users: {
        crud: lzGUsers,
    },

});

export default SystemModule;
